import React, { useState } from 'react';
import Tab from '../../Tabs/Tab';
import AdminAccountPriviliges from './AccountPriviliges/AccountPriviliges';
import AdminAccountHistory from './ActionHIstory/ActionHistory';
import AdminUserInfo from './UserInfo/UserInfo';

export default function ModalContentAdmin(props) {
    const [tabSelect, setTabSelect] = useState('user-info');
    const tabs = [
        {
            url: 'user-info', 
            name: 'User Info'
        },
        {
            url: 'account-priviliges', 
            name: 'Account Priviliges'
        },
        {
            url: 'action-history', 
            name: 'Action History'
        }
    ];
    const component = {
        'user-info': <AdminUserInfo data={props.userData} openResetPasswordPopUp={props.resetPassword}/>,
        'account-priviliges': <AdminAccountPriviliges priviledges={props.userData.acl_user_permissions.sort((a, b) => (a.acl_permission.id > b.acl_permission.id) ? 1 : (a.acl_permission.id === b.acl_permission.id) ? ((a.acl_permission.parent_id > b.acl_permission.parent_id) ? 1 : -1) : -1 )}/>,
        'action-history': <AdminAccountHistory data={props.userData} selectedActionHistory={(e) => console.log(e)} />,
    }
    return <>
        <div className="modal-content admin-modal">
            <Tab tabs={tabs} disable={true} emit={setTabSelect}/>
            {
                (
                    () => {
                        return component[tabSelect];    
                    }
                )()
            }
        </div>
    </>
}